import './error.css';
import {useEffect} from "react";
import {HideMainLoading} from "../../components/template/architecture";
export const Error404Page = () => {
    useEffect(() => {
        HideMainLoading();
        setTimeout(()=>document.body.classList.add('body-white'),50);
    }, []);
    return (
        <>
            <div className="container error-404-page" data-aos={"fade-up"} data-aos-duration={1000}>
                <div className="d-none d-lg-inline-block" style={{height:30}}/>
                <div className="d-lg-none" style={{height:50}}/>
                <div className="row align-items-center">
                    <div className="col-lg-6">
                        <a href="/" className="error-logo">
                            <img src="/logo.png" alt="نهال" />
                            <b>نهال</b>
                        </a>
                        <h1>۴۰۴</h1>
                        <p>صفحه موردنظر یافت نشد و یا شما به آن دسترسی ندارید.</p>
                        <p style={{color:'gray'}}>این یک خطا می‌باشد.</p>
                    </div>
                    <div className="col-lg-6">
                        <div className="d-lg-none" style={{height:50}}/>
                        <img className="error-404-image" src="https://tstatic.ir/svgs/v/market/error-404" alt=""/>
                        <div className="d-lg-none" style={{height:50}}/>
                    </div>
                </div>
            </div>
        </>
    )
};